export const TEST_PILOT_ANNOUNCEMENT_ID = "spacelift-test-pilot-program";
